import React from 'react';
import * as d3 from 'd3';

import './Plot.css';

export interface IMSSpectrumPlotProps { data: number[], title: string, xLabel: string, yLabel: string }

export class IMSSpectrumPlot extends React.Component<IMSSpectrumPlotProps, {}> {
    base: HTMLDivElement | null
    updateRef: (element: HTMLDivElement) => void

    constructor(props: IMSSpectrumPlotProps) {
        super(props)
        this.base = null

        this.updateRef = (element: HTMLDivElement) => {
            this.base = element;
            this.renderPlot();
        };
    }

    componentDidMount() {
        this.renderPlot();
    }

    componentDidUpdate(prevProps: IMSSpectrumPlotProps) {
        if (this.props.data !== prevProps.data) {
            this.renderPlot();
        }
    }

    renderPlot() {
        if (this.base === null)
            return;
        const width = this.base!.clientWidth - 20;  // subtract 20 to compensate for margins
        const height = this.base!.clientHeight - 20;

        const plot_margin = { top: 10, right: 10, bottom: 40, left: 70 };
        const plot_width = width - plot_margin.left - plot_margin.right;
        const plot_height = height - plot_margin.top - plot_margin.bottom;

        const xScale = d3.scaleLinear()
            .domain([0, this.props.data.length - 1])
            .range([0, plot_width]);
        const yScale = d3.scaleLinear()
            .domain([d3.min(this.props.data) || 0, d3.max(this.props.data) || 1])
            .range([plot_height, 0]);

        const line = d3.line<number>()
            .x(function (d, i) { return xScale(i) as number; })
            .y(function (d) { return yScale(d) as number; })

        d3.select(this.base!).select("svg").remove();
        const svg = d3.select(this.base!).append("svg")
            .attr("width", `${width}px`)
            .attr("height", `${height}px`);

        const xAxis = svg.append('g')
            .attr('class', 'plot-axis bottom')
        xAxis.append('g')
            .attr('transform', `translate(${plot_margin.left},${plot_height + plot_margin.top})`)
            .call(d3.axisBottom(xScale));
        xAxis.append('g')
            .attr('class', 'label')
            .append("text")
            .attr("text-anchor", "middle")
            .attr("dominant-baseline", "text-after-edge")
            .attr("transform", `translate(${plot_margin.left + plot_width / 2},${height})`)
            .text(this.props.xLabel);

        const yAxis = svg.append('g')
            .attr('class', 'plot-axis left')
        yAxis.append('g')
            .attr('transform', `translate(${plot_margin.left},${plot_margin.top})`)
            .call(d3.axisLeft(yScale));
        yAxis.append('g')
            .attr('class', 'label')
            .append("text")
            .attr("text-anchor", "middle")
            .attr("dominant-baseline", "hanging")
            .attr("transform", `translate(0,${plot_margin.top + plot_height / 2})rotate(-90)`)
            .text(this.props.yLabel);

        svg.append("g")
            .attr("class", "plot-area")
            .attr('transform', `translate(${plot_margin.left},${plot_margin.top})`)
            .append("path")
            .datum(this.props.data)
            .attr("d", line);
    }

    render() {
        return (
            <div className="Plot">
                <div className="header">
                    <span>{this.props.title}</span>
                </div>
                <div className="plot" ref={this.updateRef} />
            </div>
        )
    }
}

export default IMSSpectrumPlot
